import React, { useState } from "react";
import EmailConfirmation from "../../components/forgetPassword/Confirmation";

import { Grid, Typography } from "@mui/material";
import "./forgetPassword.scss";
const ForgetPassword = () => {
  const [page, setPage] = useState(1);
  const [authToken, setAuthToken] = useState("");

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        className="register-page"
      >
        <Grid
          container
          direction="column"
          marginTop="3rem"
          padding="1rem"
          width="30%"
          className="main-div"
        >
          <EmailConfirmation />
        </Grid>
      </Grid>
    </>
  );
};

export default ForgetPassword;
